import React from 'react'
import SmartNavigator from '../generic/SmartNavigator'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import IncidenceType from '../configuration/incidence/IncidenceType'
import Incidence from '../configuration/incidence/Incidence'

const MainIncidence = () => {
  const { t_ } = useSmartTranslation()
  const componentsInfo = [
    {
      title: t_('Incidence'),
      component: <Incidence />,
      to: '/configuration/picklist/incidence',
      permissionCode: 'INCIDENCE_TAB'
    },
    {
      title: t_('Incidence Types'),
      component: <IncidenceType />,
      to: '/configuration/picklist/incidenceTypes',
      permissionCode: 'INCIDENCE_TYPES_TAB'
    }
  ]
  return <SmartNavigator componentsInfo={componentsInfo} />
}
export default MainIncidence
